var productList = new function () {
    this.categorySortOrder = function(sortOption) {
        var selectedSortOrder = 'orderby=' + sortOption,
            updatedUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + selectedSortOrder;
        window.location = updatedUrl;
    }
    this.swapProductListImg = function (el, data) {
        var productListItemImage = $(el).closest('.product-list__product').find('.product-list__product-image'),
            swappedImg = $('<img>');
        productListItemImage.find('img').remove();
        swappedImg.attr('src', data.productImage);
        swappedImg.appendTo(productListItemImage)
    }
    this.setSwatches = function() {
        var productIds = $('.product-list__product .swatches[data-id]').map(function() {
            return $(this).data('id');
        }).get();

        if (typeof this.xhr == 'object') {
            this.xhr.abort();
        }
        this.xhr = $.ajax({
            type: 'POST',
            url: '/wp-admin/admin-ajax.php',
            dataType: 'json',
            data: {
                action: 'reality_get_swatches',
                ids: productIds,
                _wpnonce: productListOptions.getSwatches
            },
            success: function (json) {
                $.each(json.data, function(k, v) {
                    $('.swatches[data-id="'+k+'"').html(v).addClass('visible');
                });
                // $('.swatches:empty').hide();
            }
        });

        productList.selectSwatch();
    }
    this.selectSwatch = function () {
        var urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('colour')) {
            var colour = urlParams.get('colour').split('|');
            if (colour.length == 1) {
                var filter = 'colour=' + urlParams.get('colour');
                $('.product-list__product').each(function () {
                    if (!$(this).find('.swatches .swatch[data-filter="' + filter + '"]').length) {
                        return;
                    }
                    var data = $(this).find('.swatches .swatch[data-filter="' + filter + '"]').data();
                    $(this).find('.swatches .swatch').removeClass('active');
                    $(this).find('.swatches .swatch[data-filter="' + filter + '"]').addClass('active');
                    var productImage = typeof (data.productImage) !== 'undefined' ? data.productImage : '';
                    if(productImage) {
                        productList.swapProductListImg($(this), data);
                    }

                    $('.swatches .swatch').css('order', '1');
                    $('.swatches .swatch[data-filter="' + filter + '"]:not(.remaining-count)').css('order', '0').removeClass('hideShowSwatch');
                });
            }
        };
    }
    this.checkForEmptyProductList = function() {
        if($('body.tax-product_cat').length) {
            if($('.product-list').is(':empty') || !$('.product-list').length) {
                $('.product-list-columns__column--filters, .product-list-columns__column--list .product-top-filters, .product-list-columns__column--list .product-list').hide();
                $('.product-list-columns__column--filters, .product-list-columns__column--list .product-top-filters, .product-list-columns__column--list .product-best-sellers').hide();
                $('.product-list-columns, .product-list-columns__column--list').css('max-width', '100%');
            } else {
                $('.product-list-columns__column--filters, .product-list-columns__column--list .product-top-filters, .product-list-columns__column--list .product-list').show();
                $('.product-list-columns__column--filters, .product-list-columns__column--list .product-top-filters, .product-list-columns__column--list .product-best-sellers').show();
                $('.product-list-columns, .product-list-columns__column--list').css('max-width', '');
            }
        }
    }
    this.changeProductImage = function(el) {
        var el = $(el.target),
            data = $(el).data(),
            productImage = typeof (data.productImage) !== 'undefined' ? data.productImage : '';
        if(productImage) {
            productList.swapProductListImg($(el), data);
        }
        $(el).parent().find('.swatch.active').removeClass('active');
        $(el).addClass('active');
    }
    this.showRemainingSwatches = function(el) {
        var el = $(el.target);
        $(el).parents(".swatches").find('.hideShowSwatch').show(function () {
            $(el).parent().find('.toggleSwatch').find('span').remove();
            $(el).parent().find('.toggleSwatch').removeClass('remaining-count toggleSwatch');
        });
    }
    this.doDescriptionLineCount = function() {
        var el = $('.category-body--after'),
            characterCount = el.text().length;
        
        if(!el.hasClass('collapsed') && el.find('a.read-more').length) {
            return;
        }
        if(characterCount > 1000) {
            el.addClass('collapsed');
            el.append('<a href="#readmore" class="read-more" title="Read more">Read More +</a>');
        }
    }
    this.expandDescription = function() {
        var el = $('.category-body--after');
        if(el.hasClass('collapsed')) {
            var readMore = el.find('a.read-more');
            
            el.removeClass('collapsed');
            readMore.hide();
        }
    }
}
$(document).on('mouseover', '.swatches .swatch:not(.toggleSwatch)', function (el) {
    productList.changeProductImage(el);
});
$(document).on('mouseover', '.swatches .swatch.toggleSwatch', function (el) {
    productList.showRemainingSwatches(el);
});
$(document).on('change', '.woocommerce-ordering select', function() {
    productList.categorySortOrder($(this).val());
});
$(document).on('click', '.category-body--after a.read-more', function(e) {
    e.preventDefault();
    productList.expandDescription();
});
$(document).ready(function () {
    productList.checkForEmptyProductList();
    setTimeout(() => {
        productList.setSwatches();
    }, 100);

    $(window).on('ready', function(e) {
        productList.setSwatches();
    });

    $(document).ajaxComplete(function (event, xhr, settings) {
        productList.selectSwatch();
    });
    productList.doDescriptionLineCount();
});